import { render } from "./AwardBadge.vue?vue&type=template&id=43839eca"
import script from "./AwardBadge.vue?vue&type=script&lang=js"
export * from "./AwardBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__